// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_content__1YIZV","compName":"Modal_compName__19ej3","buttons":"Modal_buttons__hNRnU"};